import React, { Component } from 'react';
import Modal from './modal';
import PropTypes from 'prop-types';
import { joinClasses } from 'components/utils/react_helper';
import I18n from '~/utils/translations';

export default class ImageModal extends Component {
  render() {
    const modalProps = {
      buttonClassName: this.props.className,
      className: 'image-modal',
      gaCategory: 'image-modal',
    };

    modalProps.buttonClassName = joinClasses([this.props.className, 'image-modal__text-link']);
    modalProps.button = I18n.t(`pages.homes.${this.props.type}_text_link`);

    if (this.props.file && this.props.file.endsWith('.pdf')) {
      return (
        <a
          className={joinClasses([this.props.className, 'image-modal__text-link'])}
          href={this.props.file}
          target="_blank"
        >
          {I18n.t(`pages.homes.${this.props.type}_text_link`)}
        </a>
      );
    }

    return (
      <Modal {...modalProps}>
        <img className="image-modal__image" src={this.props.file} />
      </Modal>
    );
  }
}

ImageModal.propTypes = {
  file: PropTypes.string,
};
